import { Button } from "@mui/material";

const CustomButton = ({ children, onClick, sx = {}, ...rest }) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        height: "36px",
        textTransform: "none",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
